/**
 * Centralized PostHog event names
 *
 * All custom PostHog events should be defined here to:
 * - Maintain consistency in event naming across the app
 * - Provide documentation for what each event tracks
 * - Enable easy discovery and management of analytics
 *
 * Naming convention: SCREAMING_SNAKE_CASE for keys, lowercase_snake_case for values
 */

/**
 * PWA (Progressive Web App) related events
 * Track service worker lifecycle and update behavior
 */
export const PWA_EVENTS = {
  /**
   * Fired when service worker registration fails
   * Properties: { error: string }
   */
  REGISTRATION_ERROR: 'pwa_registration_error',

  /**
   * Fired when a new version of the app is detected and ready to install
   * Indicates an update prompt will be shown to the user
   */
  UPDATE_AVAILABLE: 'pwa_update_available',

  /**
   * Fired when the user accepts the update prompt and triggers a reload
   * Useful for measuring update adoption rate
   */
  UPDATE_ACCEPTED: 'pwa_update_accepted',

  /**
   * Fired when the user dismisses the update prompt
   * Useful for understanding user friction with updates
   */
  UPDATE_DISMISSED: 'pwa_update_dismissed',

  /**
   * Fired when the app is cached and ready for offline use
   * Indicates successful service worker installation
   */
  OFFLINE_READY: 'pwa_offline_ready',
};

/**
 * All PostHog events consolidated
 * Import this object when you need access to all event categories
 */
export const POSTHOG_EVENTS = {
  PWA: PWA_EVENTS,
};

/**
 * Type helper for extracting event name values
 */
export type PwaEventName = (typeof PWA_EVENTS)[keyof typeof PWA_EVENTS];


